var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress rounded-0",staticStyle:{"height":"6px"}},[_c('div',{staticClass:"progress-bar",style:({
            width: _vm.progress + '%',
      }),attrs:{"role":"progressbar","aria-valuenow":_vm.progress,"aria-valuemin":"0","aria-valuemax":"100"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }